module.exports = __webpack_public_path__ + "static/img/014_TO8_1475.d8717f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/014_TO8_1475.jpg
// module id = W5Kv
// module chunks = 0